import { ElkEpguResgistration, RecResgistration } from './types';

export const getMessageForElkEpgu = (reg?: ElkEpguResgistration): string => {
  if (!reg) {
    return '';
  }
  const {
    requestType,
    regDate,
    regNumber,
    registrationStatus,
    epguRequestError,
    epguRequestDate,
    epguResponseDate,
    user,
  } = reg;

  const dateText =
    [epguRequestDate?.substring(0, 16), epguResponseDate?.substring(0, 16)]
      .filter(Boolean)
      .join(' - ') || '';

  return `${requestType?.name} (заявление ${regNumber} от ${regDate}): ${
    registrationStatus?.name
  }, ${epguRequestError ? `${epguRequestError}, ` : ''}${dateText} (${user?.fio})`;
};

export const getMessageForLkRec = (reg: RecResgistration): string => {
  if (!reg) {
    return '';
  }
  const {
    requestType,
    regDate,
    regNumber,
    registrationStatus,
    requestError,
    requestDate,
    responseDate,
    user,
  } = reg;

  const dateText =
    [requestDate?.substring(0, 16), responseDate?.substring(0, 16)].filter(Boolean).join(' - ') ||
    '';

  return `${requestType?.name} (заявление ${regNumber} от ${regDate}): ${
    registrationStatus?.name
  }, ${requestError ? `${requestError}, ` : ''}${dateText} (${user?.fio})`;
};
